
import GenerateJigFormFields from '@/components/modals/GenerateJigFormFields.vue'
import Notification from '@/components/helper/Notification.vue'
import IconCloseFilled from '@svg/IconCloseFilled.svg'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    GenerateJigFormFields,
    IconCloseFilled,
    Notification,
  },
})
export default class GenerateJigFormSection extends Vue {
  @Prop({ type: Boolean, default: false })
  public isGlobalAIOptOut!: boolean

  @Prop({ type: String, default: '' })
  public errorMessage!: string

  @Prop({ type: Boolean, default: false })
  public showCompletionUnknownWarning!: boolean

  private isFieldsValid: boolean = false

  private get isGenerateEnabled(): boolean {
    return !this.isGlobalAIOptOut && this.isFieldsValid
  }

  private onFormValid(isValid: boolean) {
    this.isFieldsValid = isValid
  }

  private emitGenerate() {
    if (!this.isGenerateEnabled) {
      return
    }

    const formFields = this.$refs.formFields as InstanceType<typeof GenerateJigFormFields> | undefined
    const payload = formFields ? formFields.getPayload() : null
    if (!payload) {
      return
    }

    this.$emit('generate', payload)
  }
}
